import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { ComponentProps } from "react";
import { cn } from "../../utils";
import { Separator } from "../separator/Separator";


const buttonGroupVariants = cva(
  "al-flex al-w-fit al-items-stretch has-[>[data-slot=button-group]]:al-gap-2 [&>*]:focus-visible:al-relative [&>*]:focus-visible:al-z-10 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:al-rounded-r-md [&>[data-slot=select-trigger]:not([class*=w-])]:al-w-fit [&>input]:al-flex-1",
  {
    variants: {
      orientation: {
        horizontal:
          "[&>*:not(:first-child)]:al-rounded-l-none [&>*:not(:first-child)]:al-border-l-0 [&>*:not(:last-child)]:al-rounded-r-none",
        vertical:
          "al-flex-col [&>*:not(:first-child)]:al-rounded-t-none [&>*:not(:first-child)]:al-border-t-0 [&>*:not(:last-child)]:al-rounded-b-none",
      },
    },
    defaultVariants: {
      orientation: "horizontal",
    },
  },
);

function ButtonGroup({
                       className,
                       orientation,
                       ...props
                     }: ComponentProps<"div"> & VariantProps<typeof buttonGroupVariants>) {
  return (
    <div
      role="group"
      data-slot="button-group"
      data-orientation={orientation}
      className={cn(buttonGroupVariants({ orientation }), className)}
      {...props}
    />
  );
}

function ButtonGroupText({
                           className,
                           asChild = false,
                           ...props
                         }: ComponentProps<"div"> & {
  asChild?: boolean;
}) {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      className={cn(
        "al-bg-muted al-shadow-xs al-flex al-items-center al-gap-2 al-rounded-md al-border al-px-4 al-text-sm al-font-medium [&_svg:not([class*=size-])]:al-size-4 [&_svg]:al-pointer-events-none",
        className,
      )}
      {...props}
    />
  );
}

function ButtonGroupSeparator({
                                className,
                                orientation = "vertical",
                                ...props
                              }: React.ComponentProps<typeof Separator>) {
  return (
    <Separator
      data-slot="button-group-separator"
      orientation={orientation}
      className={cn(
        "al-bg-input al-relative al-!m-0 al-self-stretch data-[orientation=vertical]:al-h-auto",
        className,
      )}
      {...props}
    />
  );
}

export { ButtonGroup, ButtonGroupSeparator, ButtonGroupText, buttonGroupVariants };
